import script from "./theme-gallery2.vue?vue&type=script&lang=js"
export * from "./theme-gallery2.vue?vue&type=script&lang=js"

import "./theme-gallery2.vue?vue&type=style&index=0&id=60c45fd6&lang=css"

const __exports__ = script;

export default __exports__